/**
 * Row is incomplete when at least one segment has a value but at least one is empty.
 * Treat partial number range (e.g. "5>") as "has value" so we don't show error or
 * treat as empty while the user is typing min/max.
 */
export function useEmployeeByDepartmentIncompleteItem(
  values: (string | undefined)[] | undefined
) {
  if (!values?.length) return false;
  const hasValue = (x: string | undefined) => {
    if (x) return true;
    // Partial range (min only, e.g. "5>") should count as filled so input isn't reset
    if (typeof x === 'string' && x.includes('>')) return true;
    return false;
  };
  const hasAny = values.some((x) => hasValue(x));
  const hasAnyEmpty = values.some((x) => !hasValue(x));
  return hasAny && hasAnyEmpty;
}
